import { createFileRoute, retainSearchParams } from "@tanstack/react-router"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import WarehousesContainer from "@/screens/Warehouses/containers/WarehousesContainer"
import { WarehouseSearchParamsSchema } from "@/screens/Warehouses/schemas"

export const Route = createFileRoute("/app/admin/warehouses/")({
  validateSearch: WarehouseSearchParamsSchema,
  search: {
    middlewares: [retainSearchParams(["query", "field", "order", "isActive", "companyIds", "types"])],
  },
  component: () => (
    <PermissionContentWrapper permissions={[PermissionActionType.WAREHOUSES_VIEW]}>
      <WarehousesContainer />
    </PermissionContentWrapper>
  ),
})
